"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _appContext = _interopRequireDefault(require("./../../context/appContext"));
var _pageContext = _interopRequireDefault(require("./../../context/pageContext"));
var _changeLanguage = _interopRequireDefault(require("../../utils/changeLanguage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(theme => {
  var _theme$palette$foregr, _theme$palette$foregr2, _theme$palette$backgr, _theme$customTypograp;
  return {
    label: {
      color: (_theme$palette$foregr = (_theme$palette$foregr2 = theme.palette.foreground) === null || _theme$palette$foregr2 === void 0 || (_theme$palette$foregr2 = _theme$palette$foregr2.header) === null || _theme$palette$foregr2 === void 0 ? void 0 : _theme$palette$foregr2.language) !== null && _theme$palette$foregr !== void 0 ? _theme$palette$foregr : theme.palette.getContrastText((_theme$palette$backgr = theme.palette.background) === null || _theme$palette$backgr === void 0 || (_theme$palette$backgr = _theme$palette$backgr.header) === null || _theme$palette$backgr === void 0 ? void 0 : _theme$palette$backgr.appBar),
      fontWeight: 900,
      textTransform: "uppercase"
    },
    dialogTitle: {
      padding: theme.spacing(2, 3, 1, 3),
      textAlign: "center"
    },
    dialogContent: {
      padding: theme.spacing(0, 3, 2, 3),
      textAlign: "center"
    },
    headline: {
      ...(theme === null || theme === void 0 || (_theme$customTypograp = theme.customTypography) === null || _theme$customTypograp === void 0 ? void 0 : _theme$customTypograp.languageTitle)
    },
    link: {
      display: "block",
      marginBottom: theme.spacing(1),
      width: "100%",
      "&:last-child": {
        marginBottom: 0
      }
    }
  };
});
const LanguageSwitch = () => {
  const [appData] = (0, _react.useContext)(_appContext.default);
  const [open, setOpen] = (0, _react.useState)(false);
  const [languages, setLanguages] = (0, _react.useState)([]);
  const [pageData] = (0, _react.useContext)(_pageContext.default);
  const {
    t,
    i18n
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  (0, _react.useEffect)(() => {
    var _appData$languages;
    if (appData !== null && appData !== void 0 && appData.languages && (appData === null || appData === void 0 || (_appData$languages = appData.languages) === null || _appData$languages === void 0 ? void 0 : _appData$languages.length) > 0) {
      setLanguages(appData === null || appData === void 0 ? void 0 : appData.languages);
    }
  }, [appData]);
  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChangeLanguage = isoCode => {
    handleClose();
    (0, _changeLanguage.default)(i18n, isoCode);
    window.location.href = getPageUrl(isoCode);
  };
  const getPageUrl = isoCode => {
    var _pageData$data, _links$isoCode;
    const links = pageData === null || pageData === void 0 || (_pageData$data = pageData.data) === null || _pageData$data === void 0 || (_pageData$data = _pageData$data.meta) === null || _pageData$data === void 0 ? void 0 : _pageData$data.links;
    if (!links) return "/".concat(isoCode, "/");
    return (_links$isoCode = links[isoCode]) !== null && _links$isoCode !== void 0 ? _links$isoCode : "/";
  };
  if ((languages === null || languages === void 0 ? void 0 : languages.length) < 2) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    className: "language-switch",
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.label,
    component: "span"
  }, i18n.language)), languages && /*#__PURE__*/_react.default.createElement(_core.Dialog, {
    open: open,
    onClose: handleClose,
    fullWidth: true,
    maxWidth: "xs"
  }, /*#__PURE__*/_react.default.createElement(_core.DialogTitle, {
    className: css.dialogTitle
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.headline,
    component: "p"
  }, t("site.ui.headlines.language"))), /*#__PURE__*/_react.default.createElement(_core.DialogContent, {
    className: css.dialogContent
  }, languages.map((_ref, index) => {
    let {
      isoCode,
      title
    } = _ref;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, isoCode !== i18n.language && /*#__PURE__*/_react.default.createElement(_core.Box, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: css.link,
      size: "small",
      onClick: () => handleChangeLanguage(isoCode)
    }, title)));
  }))));
};
var _default = exports.default = LanguageSwitch;